var React = require('react');

function IconCaretDown24x24 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 7.00034L12 17.0003L22 7.00034","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconCaretDown24x24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconCaretDown24x24;

IconCaretDown24x24.default = IconCaretDown24x24;
